export default __webpack_public_path__ + "static/media/greenSmallTick.1c4e629d.svg";